import { useState, useEffect } from "react";
import { FaArrowUp, FaWhatsapp, FaPhone } from "react-icons/fa";
import { useBusinessConfig } from "../context/BusinessConfigContext";

const FloatingButtons = () => {
  const { contact } = useBusinessConfig();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noreferrer"
        className="whatsapp-btn" aria-label="WhatsApp">
        <FaWhatsapp />
      </a>
      <a href={`tel:${contact.phone}`} className="call-btn-mobile" aria-label="Call">
        <FaPhone />
      </a>
      <button className={`back-to-top ${show ? "show" : ""}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Back to top">
        <FaArrowUp />
      </button>
    </>
  );
};

export default FloatingButtons;
